// extracted by mini-css-extract-plugin
module.exports = {"CloseButton":"CloseButton-12yJ5","CloseIcon":"CloseIcon-OEyc6"};